/* PREST | Warenkorb: USP-Leiste nach oben  |  20.07.2026

   AUFGABE 1: Vorteils-Leiste (.prest-usp) immer nach oben
   Die drei Vorteile (Versand, Made in Portugal, Bewertung) werden serverseitig
   im Fuss gerendert. Dieses Skript haengt sie direkt ueber die Positionsliste,
   sodass sie ohne Scrollen sichtbar sind. Gilt auf Desktop und Mobil.

   Zahlungslogos bleiben bewusst unten unter dem Kauf-Button (Marc-Wunsch
   20.07.): dort schaffen sie Vertrauen im Moment der Bezahlung und sind ohne
   Scrollen sichtbar. Sie werden daher NICHT mehr umgehaengt.

   AUFGABE 2: Scroll-Hinweis
   Weiche Ausblendung am unteren Rand des Scrollbereichs, solange es weitergeht.

   AUSFALLVERHALTEN: Faellt dieses Skript aus, bleibt die USP-Leiste im Fuss
   stehen. Der Warenkorb funktioniert vollstaendig, nur die Anordnung ist dann
   die serverseitige. Kein Bedienelement haengt daran. */
(function () {
  'use strict';

  var MOBIL = window.matchMedia('(max-width: 749px)');
  var laeuft = false;

  function scrollbereich() { return document.querySelector('#CartDrawer cart-drawer-items'); }

  /* ---------- USP-Leiste nach oben ---------- */
  function umhaengen() {
    if (laeuft) return;
    laeuft = true;
    try {
      var items = scrollbereich();
      if (!items) return;

      /* insertBefore ist idempotent: nach dem Verschieben hat die Leiste
         denselben Elternknoten wie die Positionsliste und wird nicht erneut
         bewegt. Nach einem Neu-Rendern liegt eine frische Leiste wieder im
         Fuss und wird wieder hochgezogen. */
      var usp = document.querySelector('#CartDrawer .prest-usp');
      if (usp && items.parentNode && usp.parentNode !== items.parentNode) {
        items.parentNode.insertBefore(usp, items);
      }
    } catch (e) {
      if (window.console && console.warn) console.warn('[prest-cart-mobile]', e);
    } finally {
      laeuft = false;
    }
  }

  /* ---------- Scroll-Hinweis ---------- */
  function hinweisPruefen() {
    try {
      var el = scrollbereich();
      if (!el) return;
      var mehr = (el.scrollTop + el.clientHeight) < (el.scrollHeight - 4);
      el.classList.toggle('prest-mehr', mehr);
    } catch (e) { /* rein optisch, darf nie stoeren */ }
  }

  document.addEventListener('scroll', function (ev) {
    if (ev.target && ev.target.tagName === 'CART-DRAWER-ITEMS') hinweisPruefen();
  }, true);

  /* ---------- Ausloeser ---------- */
  var timer = null;
  function angestossen() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { umhaengen(); hinweisPruefen(); }, 60);
  }

  function start() {
    umhaengen();
    hinweisPruefen();
    var wurzel = document.querySelector('cart-drawer');
    if (!wurzel || !window.MutationObserver) return;
    new MutationObserver(angestossen).observe(wurzel, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  if (MOBIL.addEventListener) {
    MOBIL.addEventListener('change', function () { umhaengen(); hinweisPruefen(); });
  } else if (MOBIL.addListener) {
    MOBIL.addListener(function () { umhaengen(); hinweisPruefen(); });
  }
  window.addEventListener('resize', hinweisPruefen);
})();
